import { t as r } from "./index748.mjs";
var e = r, o = function(t) {
  return e(t.length);
};
export {
  o as l
};
